export default {
  Detail: {
    Text: {
      FixedAssetCategoryCode: 'Mã loại *',
      FixedAssetCategoryName: 'Tên loại *',
      CboFixedAssetCategory: 'Thuộc loại',
      LifeTime: 'Thời gian SD',
      DepreciationRate: 'Tỷ lệ HM năm (%)',
      AccountNumber: 'TK nguyên giá',
      CboDepreciationAccount: 'TK hao mòn',
      CboCapitalAccount: 'TK nguồn',
      Description: 'Diễn giải',
    },
    TextTooltip: {
      CboFixedAssetCategory: 'Thuộc loại tài sản cố định',
      LifeTime: 'Thời gian sử dụng',
      DepreciationRate: 'Tỷ lệ hao mòn năm',
      AccountNumber: 'Tài khoản nguyên giá',
      CboDepreciationAccount: 'Tài khoản hao mòn',
      CboCapitalAccount: 'Tài khoản nguồn',
    },
  },
};
